import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-our-partner-dialog',
  templateUrl: './our-partner-dialog.component.html',
  styleUrls: ['./our-partner-dialog.component.scss'],
})
export class OurPartnerDialogComponent implements OnInit {
  constructor(
    public partnerDialogRef: MatDialogRef<OurPartnerDialogComponent>
  ) {}

  ngOnInit() {
    this.partnerDialogRef.addPanelClass('our-partner-dialog');
  }
}
